


















































import { Component, Vue, Watch } from 'vue-property-decorator'
import Projet from '@/components/Profil/Projet.vue'
import { ApiService } from '@/api/api.service'
import { UserModule } from '@/store/modules/user'
import { getOperationID } from '@/api/operations'
import SmoothReflow from '@/components/_transitions/SmoothReflow.vue'
import { sha256 } from 'js-sha256'
import isEqual from 'lodash/isEqual'
import { TicketModule } from '../../store/modules/ticket'
import router from '../../router'

interface IAppart {
    surface: number
    exposition: string
    stage: string
    exterieur: string
    parking: number
    prix: {
        base: number
        parking: number
        exterieur: number
    }
    favori: boolean
}

@Component({
    components: {
        Projet,
        SmoothReflow,
    },
})
export default class Project extends Vue {
    apiService = new ApiService()
    apparts: IAppart[] = []
    error = null
    userID: number = null
    opeID: number = null
    choosen: boolean = false
    smoothReflowSettings = {
        transitionEvent: {
            selector: 'div',
            propertyName: 'transform',
        },
    }

    async resresh() {
        let _this = this
        if (UserModule.token == undefined) {
            UserModule.Init()
        }
        let idUser = UserModule.userInfos['id']
        this.userID = idUser

        this.opeID = await getOperationID()

        const response = await this.apiService.getBuyerProjects(
            idUser,
            this.opeID
        )
        const data = response.data

        const userOpeResp = await this.apiService.getUserOperation(
            this.userID,
            this.opeID
        )
        const userOpe = userOpeResp.data
        const favorite = (() => {
            const favoriteStr = userOpe.favorite
            if (favoriteStr) {
                try {
                    const _favorite = JSON.parse(favoriteStr)
                    const keys = Object.keys(_favorite)

                    if (keys.length) {
                        return _favorite
                    } else {
                        return null
                    }
                } catch (e) {
                    return null
                }
            }
            return null
        })()

        /**
         * Récupération du message d'erreur si nécessaire
         */
        this.error = {
            success: data.success,
            message: data.message,
        }

        /**
         * On récupère les favoris
         */
        const favorisStr = localStorage.getItem('favoris')
        let favoris = null
        if (favorisStr) {
            favoris = JSON.parse(favorisStr)
        }

        /**
         * Création de la liste des apparts à afficher
         */
        var apparts: IAppart[] = []
        if (data.success) {
            data.apartments.apartments.forEach(el => {
                const raw = {
                    ...el,
                    surface: data.apartments.surface,
                }

                const appart = {
                    surface: data.apartments.surface,
                    exposition: this.formatExposition(el.exposure),
                    stage: this.formatFloor(el.floor),
                    exterieur: data.apartments.outdoorFloor,
                    parking: parseInt(data.apartments.parking, 10),
                    prix: {
                        base: el.price,
                        parking: data.apartments.parkingPrice,
                        exterieur: data.apartments.outdoorFloorPrice,
                    },
                    favori: isEqual(raw, favorite),
                    raw,
                }

                /**
                 * On récupère l'état favori de l'appart
                 */
                // const _appart: IAppart = JSON.parse(JSON.stringify(appart))
                // delete _appart.favori
                // const _sha256 = sha256(JSON.stringify(_appart))

                // if (favoris) {
                //     appart.favori = favoris[_sha256] ? true : false
                // }

                apparts.push(appart)
            })
        }
        this.apparts = apparts
    }

    get favoris() {
        const favoris = {}
        for (var i = 0; i < this.apparts.length; i++) {
            const appart: IAppart = JSON.parse(JSON.stringify(this.apparts[i]))
            delete appart.favori
            const _sha256 = sha256(JSON.stringify(appart))
            favoris[_sha256] = this.apparts[i].favori
        }
        return favoris
    }

    @Watch('favoris')
    onFavoris(val, oldVal) {
        localStorage.setItem('favoris', JSON.stringify(this.favoris))
    }

    formatFloor(value) {
        switch (value) {
            case 'ground':
                return 'Rez-de-chaussée'
            case 'soho':
                return 'Duplex SOHO'
            case 'intermediate':
                return 'Étage intermédiaire'
            case 'top':
                return 'Dernier niveau'
            case 'house':
                return 'Maison de ville'
            default:
                return value
        }
    }

    formatExposition(value) {
        switch (value) {
            case 'north':
                return 'Nord'
            case 'east':
                return 'Est'
            case 'west':
                return 'Ouest'
            case 'south':
                return 'Sud'
            default:
                return value
        }
    }

    async onChoose(estimation) {
        const apiService = new ApiService()
        await apiService.patchSaveFavorite(this.userID, this.opeID, {
            favorite: JSON.stringify(estimation),
        })

        await TicketModule.refresh()

        if (UserModule.appartCompleted === false) {
            UserModule.markAppartAsCompleted()
        }

        this.choosen = true
    }

    reset() {
        this.choosen = false
    }

    onCancel() {
        this.$emit('cancel')
    }

    goHome() {
        this.$emit('cancel')
        router.push({ name: 'home' })
    }
}
